module.exports = __webpack_public_path__ + "static/media/kekspay_logo.7b04800c.svg";